// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"ade67c06c1eb27c10bbc","803":"cfce0716f6bfa7f26cb1"}[chunkId] + ".chunk.js";
};